import { createFileRoute } from "@tanstack/react-router"
import { GroupList } from "@/components/rema/groups"

function GroupsPage() {
  return (
    <div className="p-6">
      <GroupList />
    </div>
  )
}

export const Route = createFileRoute("/rema/groups/")({
  staticData: {
    title: 'Manage Groups',
    isSecured: true,
  },
  component: GroupsPage,
})
